import { render, staticRenderFns } from "./TemplateStepIdentificacao.vue?vue&type=template&id=26b38a2b&scoped=true"
import script from "./TemplateStepIdentificacao.vue?vue&type=script&lang=js"
export * from "./TemplateStepIdentificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b38a2b",
  null
  
)

export default component.exports